import {
    CardBody,
    CardContent,
    CardDesc,
    CardHeader,
    CardV2,
    Col,
    Container,
    Row,
} from '@design-system-etat/dsfr-react';
import React from 'react';
import * as PropTypes from 'prop-types';
import { displayStatut } from '../../../../../utils/utils';

const CarteAffichageArme = ({ arme, setArmeSelectionnee, setModaleInformationsArme }) => {
    return (
        <Col col={12} md={6} className="padding-carte">
            <CardV2 noEnlargeLink>
                <CardHeader>
                    <Container>
                        <Row className="boutons-carte">
                            <Col offset={11}>
                                <button
                                    type="button"
                                    aria-label="Plus d'informations"
                                    className="fr-icon-information-fill icone-information"
                                    onClick={() => {
                                        setArmeSelectionnee(arme);
                                        setModaleInformationsArme(true);
                                    }}
                                />
                            </Col>
                        </Row>
                    </Container>
                </CardHeader>
                <CardBody>
                    <CardContent>
                        <CardDesc>
                            <p>
                                <b>Statut </b>: {displayStatut(arme.statut)}
                            </p>
                            <p>
                                <b>Numéro d'encodage </b>: {arme.numeroEncodage}
                            </p>
                            <p>
                                <b>Type </b>: {arme.type}
                            </p>
                            <p>
                                <b>Marque </b>: {arme.marque}
                            </p>
                            <p>
                                <b>Modèle </b>: {arme.modele}
                            </p>
                            <p>
                                <b>Calibre 1 </b>: {arme.calibreCanon}
                            </p>
                            <p>
                                <b>Classement </b>: {arme.classement}
                            </p>
                            <p>
                                <b>Régime de détention </b>: {arme.regimeDetention}
                            </p>
                        </CardDesc>
                    </CardContent>
                </CardBody>
            </CardV2>
        </Col>
    );
};

CarteAffichageArme.propTypes = {
    arme: PropTypes.array.isRequired,
    setArmeSelectionnee: PropTypes.func.isRequired,
    setModaleInformationsArme: PropTypes.func.isRequired,
};

export default CarteAffichageArme;
